import { useCallback, RefObject } from 'react';
import { ChatMetaState } from '../stores/chat';
import { State } from '@hookstate/core';
import { RoundedEmojiInputRef } from '../components/RoundedEmojiInput';

export const useFocusChat = (
    inputRef: RefObject<RoundedEmojiInputRef>,
    chatMeta: State<ChatMetaState>
) => {
    return useCallback(() => {
        // we only want to focus input if the chatbox is already open to avoid unintentionally opening it.
        if (chatMeta.chatToggle.value) {
            inputRef.current?.focus();
        }
    }, [inputRef, chatMeta.chatToggle.value]);
};
